import { DefaultLayout } from "~/layouts/DefaultLayout";
import { HashtagPage } from "~/components/HashtagPage";
import { MetaHeader } from "~/components/MetaHeader";
import { useLoaderData, Link, LoaderFunction } from 'remix'
import { SupabaseClientFn } from '~/utils/db.server';



export const loader: LoaderFunction = async ({ request }) => {
    // リクエストURLからURLオブジェクトを作成
    const url = new URL(request.url);

    // URLオブジェクトからクエリパラメータを取得
    const hashtagId = url.searchParams.get('hashtag_id');

    // クエリパラメータがnullまたはundefinedでないことを確認
    if (!hashtagId) {
        throw new Response("Not Found", { status: 404 });
    }

    // Supabaseからデータを取得
    const { data, error } = await SupabaseClientFn
        .from('hashtags_shops')
        .select(`shops!inner(shop_name,shop_id,blog_detail_path,instagram_name),hashtags!inner(hashtag_name,hashtag_desc)`)
        .eq('hashtag_id', hashtagId);

    if (error) {
        throw new Response(error.message, { status: 500 });
    }
    const randomData = data.sort(() => 0.5 - Math.random()).slice(0, 15);
    return randomData;
};

const Cafe: React.VFC = () => {
    const data = useLoaderData<HashtagShopsData>();
    return (
        <>
            <MetaHeader title={data[0].hashtags.hashtag_name + ' - 福岡カフェ日記 | 福岡最大級のカフェメディア'} description={data[0].hashtags.hashtag_desc} />
            <DefaultLayout>
                <HashtagPage hashtagData={data} />
            </DefaultLayout>
        </>
    );
};

export default Cafe;
